// Validate a list of { from, until } date ranges.
// Returns an error string (German) or null when valid.
//
// Regeln:
// - Innerhalb eines Zeitraums darf "ab" nicht nach "bis" liegen.
// - Bei mehreren Zeiträumen sind offene Ränder nur am Anfang/Ende erlaubt:
//   Jeder Zeitraum, auf den ein weiterer folgt, muss ein "bis"-Datum haben,
//   und jeder Zeitraum, dem einer vorausgeht, muss ein "ab"-Datum haben.
export const validateDateRanges = (ranges) => {
  const list = ranges || [];
  for (let i = 0; i < list.length; i++) {
    const r = list[i] || {};
    if (r.from && r.until && r.from > r.until) {
      return `Zeitraum ${i + 1}: Das "ab"-Datum muss vor dem "bis"-Datum liegen!`;
    }
    if (i < list.length - 1 && !r.until) {
      return `Zeitraum ${i + 1}: Bitte ein "bis"-Datum angeben, da ein weiterer Zeitraum folgt.`;
    }
    if (i > 0 && !r.from) {
      return `Zeitraum ${i + 1}: Bitte ein "ab"-Datum angeben.`;
    }
  }
  return null;
};
